/* unplugin-vue-components disabled */import { render } from "./protocolProduct.vue?vue&type=template&id=15598f40&scoped=true"
import script from "./protocolProduct.vue?vue&type=script&lang=js"
export * from "./protocolProduct.vue?vue&type=script&lang=js"

import "./protocolProduct.vue?vue&type=style&index=0&id=15598f40&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.15_webpack@5.89.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15598f40"]])

export default __exports__